/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_Section_HeaderInputs */

const en_wallet_card_section_header = /** @type {(inputs: Wallet_Card_Section_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wallet Card`)
};

const fr_wallet_card_section_header = /** @type {(inputs: Wallet_Card_Section_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte de portefeuille`)
};

/**
* | output |
* | --- |
* | "Wallet Card" |
*
* @param {Wallet_Card_Section_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_section_header = /** @type {((inputs?: Wallet_Card_Section_HeaderInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_Section_HeaderInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_section_header(inputs)
	return fr_wallet_card_section_header(inputs)
});